<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">ประวัติการใช้งานเครดิต</h1>
                    <p class="text-white pb-3 px-3">ดูรายงานยอดเครดิตเข้า-ออก</p>
                </div>
                <div class="col-12 col-md-12 col-lg-5 align-self-center px-3 text-right">
                    <!-- <h1 class="display-3 text-white">
                        <small>ยอดเครดิตเข้าทั้งหมด</small>
                        <small>บาท</small>
                    </h1>
                    <h1 class="display-3 text-white">
                        <small>ยอดเครดิตออกทั้งหมด</small>
                        <small>บาท</small>
                    </h1> -->
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-lg-7">
                                    <b-form-group id="input-group-1" label="ค้นหาวันที่ทำรายการ (วันเริ่มต้น - วันสุดท้าย)" label-for="input-1" class="mb-0">
                                        <div class="row align-self-center">
                                            <div class="col-lg-5">
                                                <date-range-picker
                                                    class="w-100"
                                                    :opens="'center'"
                                                    @start-selection="logEvent('startSelection', $event)"
                                                    @finish-selection="logEvent('finishSelection', $event)"
                                                    :min-date="minDate"
                                                    :max-date="maxDate"
                                                    :singleDatePicker="false"
                                                    :appendToBody="true"
                                                    :ranges="false"
                                                    :closeOnEsc="false"
                                                    :autoApply="true"
                                                    :locale-data="{ format: 'dd-mm-yyyy' }"
                                                    v-model="filters">
                                                </date-range-picker>
                                            </div>
                                            <div class="col-lg-5">
                                                <select class="form-control" v-model="filterStatus">
                                                    <option :value="status.key" v-for="status in dataStatus" :key="status.key">{{status.title}}</option>
                                                </select>
                                            </div>
                                            <div class="col-lg-2">
                                                <button class="btn btn-info btn-sm-res" @click="historyUsageWalletAPI()">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <hr class="d-block d-md-none d-lg-none mb-0" />
                                </div>
                                <div class="col-lg-3">
                                    <b-form-group label="ตัวกรอง" label-for="input-1" class="mb-0">
                                        <b-form-input v-model="filter" type="text" placeholder="ค้นหาข้อมูลในตาราง"></b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-2">
                                    <b-form-group label="Export File" class="mb-0 pb-2">
                                        <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                                            <ExportExcel
                                                :columns="fields('excel')"
                                                :getData="getDataBranceExportExcel"
                                                name="สรุปการใช้งาน wellet "
                                            >
                                            </ExportExcel>
                                            <b-button variant="info btn-sm-res" @click="$htmlToPaper('tablePrint')">print</b-button>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div id="tablePrint">
                            <b-table
                                show-empty
                                responsive
                                empty-text="ไม่มีรายละเอียดการใช้งานเครดิต"
                                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                                :tbody-tr-class="rowClass"
                                :items="dataUsegeWallet"
                                :fields="fields()"
                                :filter="filter"
                                :busy="busy"
                                class="scroll-bar-pop"
                            >
                                <div slot="table-busy" class="text-center">
                                    <BlockUI>
                                        <div class="loader"></div>
                                    </BlockUI>
                                </div>
                                <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                                <template slot="created_at" slot-scope="row">{{ row.item.created_at | dateFormat }}</template>
                                <template slot="subject" slot-scope="row">
                                    <span>
                                        {{statusPaymentSubject(row.item.subject).text}}
                                    </span>
                                </template>
                                <template slot="credit" slot-scope="data">
                                    <span :class="rowClassTransaction(data.item).fontColor">
                                        {{rowClassTransaction(data.item).text}}
                                    </span>
                                </template>
                                 <template slot="status" slot-scope="row">
                                    <b-badge
                                        :variant="statusPayment(row.item.status, row.item.subject).color"
                                        class="d-block"
                                    >
                                        <i :class="statusPayment(row.item.status, row.item.subject).icon"></i>
                                        {{statusPayment(row.item.status, row.item.subject).status}}
                                    </b-badge>
                                </template>
                            </b-table>
                            <div class="mt-3">
                                <b-pagination
                                    :total-rows="pagination.totalItem"
                                    :current-page="pagination.currentPage"
                                    :per-page="pagination.perPpage"
                                    :value="pagination.currentPage"
                                    @input="changePage"
                                    align="right" >
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'
import { setFormatEmptyValue } from "@/helpers/util.js"
import {
    statusPaymentSubject, statusPayment, rowClass, rowClassTransaction, convertDataWallet
} from "@/axios/walletPayment.js"
import { dateLimitRanges } from "@/plugins/datePicker.js"

export default {
    name: "historyusagewallet",
    components:{
        ExportExcel
    },
    data() {
        return {
            busy: false,
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            filters: {
                excelDate: "",
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
            filter: null,
            filterStatus: null,
            dataStatus:[
                { key: null , title:'ดูประเภทรายการทั้งหมด'},
                { key: 'deposit' , title: 'ค่าขนส่ง' },
                // { key: 'REFUND' , title: 'คืนเครดิตสาขา' },
                { key: 'withdraw' , title: 'ถอนเครดิต' }
            ],
            dataUsegeWallet:[],
            pagination:{
                currentPage: 1,
                perPage: 20,
                totalPage: 1,
                totalItem: 0

            },
            statusPaymentSubject: statusPaymentSubject,
            statusPayment: statusPayment,
            rowClass: rowClass,
            rowClassTransaction: rowClassTransaction
        }
    },
    filters: {
        dateFormat(date) {
            return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
        },
    },
    mounted() {
        this.historyUsageWalletAPI()
    },
    methods: {
        logEvent( event , date ){
            const { minDate , maxDate } =  dateLimitRanges(event, date);
            this.minDate = minDate
            this.maxDate = maxDate
        },
        changePage(i){
            if (this.pagination.currentPage == i) return
            const page = this.pagination.currentPage = i
            this.historyUsageWalletAPI( page )
        },
        async historyUsageWalletAPI( page = 1 ){
            this.busy = true
            await this.$http.get(
                    this.$API_URL + "/wallet/agent/transaction/info",{
                        headers: {
                            Token: localStorage.getItem("access_token")
                        },
                        params: {
                            date_start: moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss"),
                            date_end: moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss"),
                            subject: this.filterStatus,
                            myWallet: true,
                            page: page
                        }
                    }
                )
                .then(res => {
                    let _data = res.data.data
                    this.dataUsegeWallet = _data.data
                    this.pagination.totalPage = _data.total_page
                    this.pagination.perPage = _data.per_page
                    this.pagination.totalItem = _data.total_item
                    this.pagination.currentPage = _data.page
                }).catch(error => {
                    //do something pls P'nathe
                })
                this.busy = false
        },
        async getDataBranceExportExcel() {
            return new Promise( resolve => {
                let ExcelTask = []
                let page = 1;
                for( let i = 0 ; i < this.pagination.totalPage; i++ ){
                    ExcelTask.push( this.$http
                        .get(
                            this.$API_URL + "/wallet/agent/transaction/info",{
                                headers: {
                                    Token: localStorage.getItem("access_token")
                                },
                                params: {
                                    date_start: moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                    date_end: moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                    subject: this.filterStatus,
                                    myWallet: true,
                                    page: page++
                                }
                            }
                        )
                    )
                }
                Promise.all(ExcelTask).then( (resData) => {
                    let dataExcel = [];
                    resData.forEach( data => {
                        let results = convertDataWallet(data.data.data.data)
                        dataExcel.push(...results)

                    })
                    resolve(dataExcel)
                })
            })
        },
        fields(type = null){
            let fields = [
                { key: "index", field: "index", label: "ลำดับ", sortable: true },
                { key: "created_at", field: "created_at", label: "วันเวลาที่ทำรายการ", sortable: true , class:"text-center" },
                { key: "transaction_id", field: "transaction_id", label: "เลขที่รายการ", sortable: true , class:"text-center" },
                {
                    key: "subject",
                    field: "subject",
                    label: "ประเภทรายการ",
                    class:"text-center",
                    sortable: true,

                },
                { key: "credit", field: "credit", label: "Transaction", sortable: true , class:"text-center" },
                {
                    key: "status",
                    field: "status",
                    label: "สถานะ",
                    sortable: true,
                    class:"text-center"
                },
                // { key: "credit_withdraw", field: "credit_withdraw", label: "เครดิตออก", sortable: true , class:"text-center" },
                { key: "available_credit", field: "available_credit", label: "เครดิตที่ใช้ได้", sortable: true , class:"text-center" },
                { key: "accumulated_credit", field: "accumulated_credit", label: "เครดิตคงเหลือ", sortable: true , class:"text-center" },
                { key: "ref_no2", field: "ref_no2", label: "หมายเหตุ", sortable: true , class:"text-center" }
            ]
            // เอาลำดับออกนะครับ :)
            if( type === 'excel' ) fields.splice(0, 1)
            return fields
        }
    }
};
</script>
